import { render, staticRenderFns } from "./HomeNewsTrends.vue?vue&type=template&id=451542e0&scoped=true&"
import script from "./HomeNewsTrends.vue?vue&type=script&lang=ts&"
export * from "./HomeNewsTrends.vue?vue&type=script&lang=ts&"
import style0 from "./HomeNewsTrends.vue?vue&type=style&index=0&id=451542e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451542e0",
  null
  
)

export default component.exports